<template>
    <view class="cus-date-picker">
        <picker-view class="picker-view" :value="pickerValue" @change="handlePickerChange" :indicator-style="indicatorStyle" :item-height="50">
            <template v-if="type === 'date'">
                <picker-view-column class="picker-column">
                    <view class="picker-item" v-for="year in years" :key="year">{{ year }}年</view>
                </picker-view-column>
                <picker-view-column class="picker-column">
                    <view class="picker-item" v-for="month in months" :key="month">{{ month }}月</view>
                </picker-view-column>
                <picker-view-column class="picker-column">
                    <view class="picker-item" v-for="day in days" :key="day">{{ day }}日</view>
                </picker-view-column>
            </template>
            <template v-if="['dateTime', 'time'].includes(type)">
                <picker-view-column class="picker-column">
                    <view class="picker-item" v-for="hour in hours" :key="hour">{{ hour }}时</view>
                </picker-view-column>
                <picker-view-column class="picker-column">
                    <view class="picker-item" v-for="minute in minutes" :key="minute">{{ minute }}分</view>
                </picker-view-column>
            </template>
        </picker-view>
    </view>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import moment from 'moment';

    // 指示器样式
    const indicatorStyle = 'height: 50px;';

    const props = defineProps({
        modelValue: {
            type: [Date, String],
            default: null
        },
        type: {
            type: String,
            default: 'dateTime'
        },
        minDateTime: {
            type: [Date, String],
            default: null
        }
    });

    const emit = defineEmits(['update:modelValue', 'change']);

    // 初始化日期时间
    const initDateTime = props.modelValue ? moment(props.modelValue) : moment();

    // 年份范围：当前年份前后10年
    const currentYear = moment(initDateTime).year();
    const years = computed(() => {
        const arr = [];
        for (let i = currentYear - 80; i <= currentYear + 10; i++) {
            arr.push(i);
        }
        return arr;
    });

    // 月份
    const months = computed(() => {
        const arr = [];
        for (let i = 1; i <= 12; i++) {
            arr.push(i);
        }
        return arr;
    });

    // 日期
    const days = computed(() => {
        const arr = [];
        const year = selectedYear.value;
        const month = selectedMonth.value;
        const daysInMonth = moment(`${year}-${month}`, 'YYYY-M').daysInMonth();
        for (let i = 1; i <= daysInMonth; i++) {
            arr.push(i);
        }
        return arr;
    });

    // 小时
    const hours = computed(() => {
        const arr = [];
        for (let i = 0; i <= 23; i++) {
            arr.push(i);
        }
        return arr;
    });

    // 分钟
    const minutes = computed(() => {
        const arr = [];
        for (let i = 0; i <= 59; i++) {
            arr.push(i);
        }
        return arr;
    });

    // 选中的值
    const selectedYear = ref(moment(initDateTime).year());
    const selectedMonth = ref(moment(initDateTime).month() + 1);
    const selectedDay = ref(moment(initDateTime).date());
    const selectedHour = ref(moment(initDateTime).hour());
    const selectedMinute = ref(moment(initDateTime).minute());

    // picker-view的value
    const pickerValue = computed(() => {
        const yearIndex = years.value.indexOf(selectedYear.value);
        const monthIndex = selectedMonth.value - 1;
        const dayIndex = selectedDay.value - 1;
        const hourIndex = selectedHour.value;
        const minuteIndex = selectedMinute.value;
        if (props.type == 'date') {
            return [yearIndex, monthIndex, dayIndex, hourIndex, minuteIndex];
        } else {
            return [hourIndex, minuteIndex];
        }
    });

    // 处理picker-view变化
    const handlePickerChange = (e) => {
        if (props.type == 'date') {
            const [yearIndex, monthIndex, dayIndex, hourIndex, minuteIndex] = e.detail.value;
            selectedYear.value = years.value[yearIndex];
            selectedMonth.value = monthIndex + 1;
            selectedDay.value = dayIndex + 1;
            selectedHour.value = hourIndex;
            selectedMinute.value = minuteIndex;

            updateDateTime();
        } else {
            const [hourIndex, minuteIndex] = e.detail.value;

            selectedHour.value = hourIndex;
            selectedMinute.value = minuteIndex;

            updateDateTime();
        }
    };

    // 更新日期时间
    const updateDateTime = () => {
        const newDateTime = moment({
            year: selectedYear.value,
            month: selectedMonth.value - 1,
            day: selectedDay.value,
            hour: selectedHour.value,
            minute: selectedMinute.value
        }).format('YYYY-MM-DD HH:mm:ss');
        emit('update:modelValue', newDateTime);
        emit('change', newDateTime);
    };

    // 监听外部传入的值变化
    watch(
        () => props.modelValue,
        (newVal) => {
            const dateTime = newVal ? moment(newVal) : moment();
            selectedYear.value = dateTime.year();
            selectedMonth.value = dateTime.month() + 1;
            selectedDay.value = dateTime.date();
            selectedHour.value = dateTime.hour();
            selectedMinute.value = dateTime.minute();
        },
        { immediate: true }
    );
</script>

<style lang="scss" scoped>
    .cus-date-picker {
        width: 100%;
        height: 52px;
        background-color: #fff;
        overflow: hidden;
        border: 1px solid #cacaca;
        border-left: none;
        border-right: none;
        .picker-view {
            width: 100%;
            height: 100%;
            .picker-column {
                height: 100%;
                flex: 1;
                width: 100px;

                .picker-item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // height: 50px;
                    font-size: 20px;
                    color: #333;
                    // padding: 0 4px;
                }
            }
        }
    }
</style>
